import { render } from "./HeaderContent.vue?vue&type=template&id=490133c2"
import script from "./HeaderContent.vue?vue&type=script&lang=js"
export * from "./HeaderContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__